import React from 'react';

export interface BrowseToolbarProps {
  search?: React.ReactNode;
  primaryFilters?: React.ReactNode;
  secondaryFilters?: React.ReactNode;
  sort?: React.ReactNode;
  view?: React.ReactNode;
  layout?: 'default' | 'adaptive-grid';
}

const BrowseToolbar: React.FC<BrowseToolbarProps> = ({
  search,
  primaryFilters,
  secondaryFilters,
  sort,
  view,
  layout = 'default',
}) => (
  <div className="rounded-xl bg-white p-4 shadow-sm ring-1 ring-gray-200 dark:bg-gray-900 dark:ring-gray-800">
    {layout === 'adaptive-grid' ? (
      <div
        data-testid="browse-toolbar-adaptive-grid"
        className="grid min-w-0 grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4"
      >
        {search && <div className="w-full min-w-0">{search}</div>}
        {primaryFilters && <div className="contents">{primaryFilters}</div>}
        {sort && <div className="contents">{sort}</div>}
        {view && <div className="w-full min-w-0">{view}</div>}
      </div>
    ) : (
      <div className="flex min-w-0 flex-col gap-3 lg:flex-row lg:items-end">
        {search && <div className="w-full min-w-0 lg:flex-1">{search}</div>}
        {primaryFilters && <div className="flex min-w-0 flex-wrap gap-3">{primaryFilters}</div>}
        <div className="flex min-w-0 flex-wrap items-end gap-3">
          {sort}
          {view}
        </div>
      </div>
    )}
    {secondaryFilters && (
      <details className="mt-3 border-t border-gray-200 pt-3 dark:border-gray-700">
        <summary className="inline-flex min-h-11 cursor-pointer items-center rounded-md px-2 text-sm font-semibold text-club-blue-700 transition-colors hover:bg-club-blue-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-club-blue-500 motion-reduce:transition-none dark:text-club-blue-300 dark:hover:bg-club-blue-950">
          More filters
        </summary>
        <div className="mt-3 flex min-w-0 flex-wrap gap-3">{secondaryFilters}</div>
      </details>
    )}
  </div>
);

export default BrowseToolbar;
